(function() {
  function attachEmailJS() {
    var form = document.getElementById('ContactForm-ask');
    if (form && !form.dataset.emailjsAttached) {
      form.dataset.emailjsAttached = 'true';

      // Aggiungi il widget Turnstile invisibile al form
      var turnstileDiv = document.createElement('div');
      turnstileDiv.id = 'turnstile-widget';
      form.appendChild(turnstileDiv);

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var params = {
          to_email: "stefano@piombini.it",
          from_name: form.querySelector('[name="contact[Name]"]')?.value || '',
          from_email: form.querySelector('[name="contact[email]"]')?.value || '',
          phone: form.querySelector('[name="contact[Phone number]"]')?.value || '',
          message: form.querySelector('textarea')?.value || '',
          product_title: form.querySelector('[name="contact[Product Title]"]')?.value || '',
          product_link: form.querySelector('[name="contact[Product Link]"]')?.value || ''
        };

        // Esegui Turnstile invisibile, poi invia
        turnstile.execute('#turnstile-widget', {
          sitekey: '0x4AAAAAAD4rdSA0tmVN58yv',
          callback: function(token) {
            if (!token) {
              console.warn("Turnstile: bot rilevato, invio bloccato.");
              return;
            }

            fetch("https://api.emailjs.com/api/v1.0/email/send", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                service_id: "service_5eu4yem",
                template_id: "template_mpav3ed",
                user_id: "0-oU2UzOngSwJG02t",
                template_params: params
              }),
              keepalive: true
            })
            .then(function() { console.log("EmailJS: inviato!"); })
            .catch(function(err) { console.error("EmailJS error:", err); })
            .finally(function() {
              // Lascia procedere il form nativo di Shopify
              form.dataset.emailjsAttached = 'done';
              form.submit();
            });
          }
        });
      });
    }
  }

  // Carica Turnstile SDK
  var script = document.createElement('script');
  script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  script.async = true;
  script.defer = true;
  script.onload = function() {
    attachEmailJS();
  };
  document.head.appendChild(script);

  // MutationObserver per popup caricati dinamicamente
  var observer = new MutationObserver(function() {
    if (typeof turnstile !== 'undefined') {
      attachEmailJS();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
